const SESSION_OPTIMIZATION_SHOWN_KEY = "redo.session-optimization-shown";

export function hasShownOptimizationThisSession(): boolean {
  return sessionStorage.getItem(SESSION_OPTIMIZATION_SHOWN_KEY) === "true";
}

export function markOptimizationShownInSession(): void {
  sessionStorage.setItem(SESSION_OPTIMIZATION_SHOWN_KEY, "true");
}
